import { combineReducers } from 'redux';
import ChangeLayoutMode from './theme-layout/reducers';
import { bizReducer } from '../actions/reducers';
import { getSession } from '../services/storage-service';
import { SESSION_KEYS } from '../utilities/constants';

const bizCode = getSession(`${SESSION_KEYS.DEFAULT_BIZ_CODE}`);
const key = `${bizCode}${SESSION_KEYS.LOGIN_RES}`;
const loginRes = getSession(`${key}`, true) || {};

const rootReducers = combineReducers({
  auth: loginRes,
  ChangeLayoutMode,
  biz: bizReducer,
});

export default rootReducers;
